<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
            v-model="searchForm.userName"
            placeholder="商户名"
            style="width: 200px;"
          />
        </el-form-item>

        <el-form-item
        >
          <el-input
                  v-model="searchForm.userCode"
                  placeholder="商户账号"
                  style="width: 200px;"
          />
        </el-form-item>
        <el-form-item
        >
          <el-select
                  class="filter-item"
                  v-model="searchForm.pass"
                  placeholder="状态"
                  width="50"
          >
            <el-option
                    v-for="item in bsOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="商户名"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>

      <el-table-column
        label="姓名"
        prop="legal"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.legal}}
        </template>
      </el-table-column>
      <el-table-column
        label="联系电话"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.mobileNo}}
        </template>
      </el-table-column>
      <el-table-column
        label="商户账号"
        prop="userCode"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.userCode}}
        </template>
      </el-table-column>
      <el-table-column
              label="经营类别"
              prop="userCode"
              sortable="custom"
              :show-overflow-tooltip="true"
              width="150"
      >
        <template slot-scope="scope">
          {{scope.row.one_type_name}}-{{scope.row.two_type_name}}-{{scope.row.three_type_name}}
        </template>
      </el-table-column>
      <el-table-column
              label="归属上级"
              prop="userCode"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.pagentid}}
        </template>
      </el-table-column>
      <el-table-column
              label="折扣"
              prop="gyj_discount"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.gyj_discount}}
        </template>
      </el-table-column>
      <el-table-column
              label="是否开通服务"
              prop="pass"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.openid=='1'">
           已开通
          </div>
          <div v-else>
          未开通
          </div>

        </template>
      </el-table-column>
      <el-table-column
              label="是否开通精准推送"
              prop="pass"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.appid=='1'">
            已开通
          </div>
          <div v-else>
            未开通
          </div>

        </template>
      </el-table-column>
      <el-table-column
              label="是否开通多维超媒"
              prop="pass"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.accessIp=='1'">
            已开通
          </div>
          <div v-else>
            未开通
          </div>

        </template>
      </el-table-column>
      <el-table-column
              label="状态"
              prop="pass"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.pass=='0'">
            已签约
          </div>
          <div v-else-if="scope.row.pass=='1'  || scope.row.pass=='3'">
            未开通
          </div>
          <div v-else-if="scope.row.pass=='2'">
            待审核
          </div>
          <div v-else-if="scope.row.pass=='5'">
            <div v-if="scope.row.parts_no==''">
              未微信进件
            </div>
            <div v-else-if="scope.row.parts_no!=''">
              已提交微信进件、待微信审核
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="350"
      >
          <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">编辑</el-button>
            <el-button type="primary" plain size="mini"    @click="openViewForm(scope.row)">详情</el-button>

          <el-button type="primary" plain size="mini"      v-if="scope.row.pass=='1'  && (is_dl_type=='-1' || is_agentid=='7080007')  "  @click="del(scope.row.agentid,0)">启用</el-button>

          <el-button type="primary" plain size="mini"     v-if="scope.row.pass=='0'  && (is_dl_type=='-1' || is_agentid=='7080007')  " @click="del(scope.row.agentid,1)">禁用</el-button>
            <el-button type="primary" plain size="mini"     v-if="scope.row.openid=='1' && scope.row.pass=='0'  && (is_dl_type=='-1' || is_agentid=='7080007')  " @click="dell(scope.row.agentid,0)">服务关闭</el-button>
            <el-button type="primary" plain size="mini"     v-if="(scope.row.openid=='0' || scope.row.openid=='') && scope.row.pass=='0' && (is_dl_type=='-1' || is_agentid=='7080007')  " @click="dell(scope.row.agentid,1)">服务开启</el-button>
            <el-button type="primary" plain size="mini"     v-if="scope.row.appid=='1' && scope.row.pass=='0'  && (is_dl_type=='-1' || is_agentid=='7080007')  " @click="dellj(scope.row.agentid,0)">精准推送关闭</el-button>
            <el-button type="primary" plain size="mini"     v-if="(scope.row.appid=='0' || scope.row.appid=='') && scope.row.pass=='0' && (is_dl_type=='-1' || is_agentid=='7080007')  " @click="dellj(scope.row.agentid,1)">精准推送开启</el-button>
            <el-button type="primary" plain size="mini"     v-if="scope.row.accessIp=='1' && scope.row.pass=='0'  && (is_dl_type=='-1' || is_agentid=='7080007')  " @click="deldw(scope.row.agentid,0)">多维超媒关闭</el-button>
            <el-button type="primary" plain size="mini"     v-if="(scope.row.accessIp=='0' || scope.row.accessIp=='') && scope.row.pass=='0' && (is_dl_type=='-1' || is_agentid=='7080007')  " @click="deldw(scope.row.agentid,1)">多维超媒开启</el-button>
              <el-button type="primary" plain size="mini"    @click="reset(scope.row.userId)">重置密码</el-button>


        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :agent="agent"
      :accuseVisible="accuseVisible"
      v-model="editFormVisible"
      @submit="getTableData"
    />
    <view-form
            :agent="agent"
            v-model="viewFormVisible"
            @submit="getTableData"
    />
  </d2-container>
</template>
<script>
import * as agentService from "@/api/sys/agent";
import editForm from "./editForm"
import util from '@/libs/util.js'
import viewForm from "./viewForm"
export default {
  name: "ShopsPage",
  components: { editForm,viewForm},
  data() {
    return {
      searchForm: {
          userName: "",
          userCode: ""
      },
        bsOptions: [
            {
                value: "3",
                label: "未开通"
            },
            {
                value: "2",
                label: "待审核"
            },
            {
                value: "0",
                label: "已签约"
            },
            {
                value: "4",
                label: "签约失败"
            }, {
                value: "5",
                label: "已提交微信进件、待微信审核"
            },
            {
                value: "6",
                label: "未微信进件"
            }
        ],
        accuseVisible:true,
      loading: false,
      tableData: [],
      multipleSelection: [],
        is_agentid:util.cookies.get('agentid'),
        is_dl_type:util.cookies.get('dl_type'),
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        agent: {},
      viewFormVisible: false,
      editFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
          dl_type: util.cookies.get('dl_type'),
          xt_id:util.cookies.get('xt_id'),
          dl_type2:'4',
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getAgentPagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(agent) {
          this.agent = agent;
          this.editFormVisible = true;
        this.accuseVisible=true;
      },
    openSjbbForm(agent) {
      this.agent = agent;
      this.viewFormVisible = true;
    },
      openViewForm(agent) {
          this.agent = agent;
          this.editFormVisible = true;
          this.accuseVisible=false;
      },
    add() {
      this.agent = {};
      this.editFormVisible = true;
        this.accuseVisible=true;
    },
    reset(userId) {
        let msg = "重置密码";
        this.$confirm("确定要重置该帐号的密码吗？！重置后的密码为123456", "确认信息", {
            distinguishCancelAndClose: true,
            confirmButtonText: msg,
            cancelButtonText: "取消"
        }).then(() => {
            agentService.resetAgent({userId:userId}).then(() => {
                this.getTableData();
            });
        });
    },
    wxjj(agentid) {
          let msg = "申请微信特约商户,提交后微信需要1-2天审核,申请后需要登陆服务商平台查看申请状态" ;
          this.$confirm("确认"+msg+"操作？", "确认信息", {
              distinguishCancelAndClose: true,
              confirmButtonText: "申请",
              cancelButtonText: "取消"
          }).then(() => {
              agentService.wxjj({agentid:agentid}).then(data => {

                  if(data==null || data=="" ) {
                      this.getTableData();
                  }

              });
          });
      },
    dell(agentid,type) {
      let msg = type == 1 ? "服务开启" : "服务关闭";
      this.$confirm("确认"+msg+"操作？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: "取消"
      }).then(() => {
        agentService.dellAgent({agentid:agentid,type:type}).then(() => {


            this.getTableData();


        });
      });
    },
    dellj(agentid,type) {
      let msg = type == 1 ? "精准推送开启" : "精准推送关闭";
      this.$confirm("确认"+msg+"操作？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: "取消"
      }).then(() => {
        agentService.delljAgent({agentid:agentid,type:type}).then(() => {


          this.getTableData();


        });
      });
    },
    deldw(agentid,type) {
      let msg = type == 1 ? "多维超媒开启" : "多维超媒关闭";
      this.$confirm("确认"+msg+"操作？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: "取消"
      }).then(() => {
        agentService.deldwAgent({agentid:agentid,type:type}).then(() => {


          this.getTableData();


        });
      });
    },
    del(agentid,type) {
        let msg = type == 1 ? "禁用" : "启用";
      this.$confirm("确认"+msg+"操作？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: msg,
        cancelButtonText: "取消"
      }).then(() => {
          agentService.delAgent({agentid:agentid,type:type}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
